/**
 * Collection grid: append next page via Section Rendering API.
 * - Click triggers load; IntersectionObserver preloads when the control nears the viewport.
 * - Re-binds after facet AJAX replaces #ProductGridContainer (MutationObserver).
 * - Paused while gender filter is active (short filtered grids must not infinite-scroll).
 */
(function () {
  if (document.documentElement.dataset.platiniCollectionLoadMore) return;
  document.documentElement.dataset.platiniCollectionLoadMore = 'true';

  var autoLoadObserver = null;
  var isLoading = false;
  var mutationTimer = null;
  var paused = false;

  function isAutoLoadPaused() {
    return (
      paused ||
      document.documentElement.dataset.platiniPauseCollectionAutoLoad === 'true' ||
      (window.PlatiniGenderFilter && window.PlatiniGenderFilter.getActive && window.PlatiniGenderFilter.getActive())
    );
  }

  function disconnectAutoLoad() {
    if (autoLoadObserver) {
      autoLoadObserver.disconnect();
      autoLoadObserver = null;
    }
  }

  function setupAutoLoad() {
    disconnectAutoLoad();
    if (isAutoLoadPaused()) return;

    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var wrap = container.querySelector('[data-collection-load-more]');
    if (!wrap) return;
    var btn = wrap.querySelector('[data-load-more]');
    if (!btn || btn.disabled) return;

    autoLoadObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || isLoading || isAutoLoadPaused()) return;
          var b = entry.target.querySelector('[data-load-more]');
          if (b && !b.disabled) loadNextPage(b);
        });
      },
      { root: null, rootMargin: '400px 0px', threshold: 0 }
    );
    autoLoadObserver.observe(wrap);
  }

  function scheduleAutoLoadCheck() {
    disconnectAutoLoad();
    requestAnimationFrame(setupAutoLoad);
  }

  function observeProductGridContainer() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid || grid.dataset.platiniLoadMoreMutationBound) return;
    grid.dataset.platiniLoadMoreMutationBound = 'true';
    new MutationObserver(function () {
      clearTimeout(mutationTimer);
      mutationTimer = setTimeout(scheduleAutoLoadCheck, 60);
    }).observe(grid, { childList: true });
  }

  function loadNextPage(btn) {
    if (!btn || isLoading) return;

    var container = document.getElementById('ProductGridContainer');
    if (!container || !container.contains(btn)) return;

    var wrap = btn.closest('[data-collection-load-more]');
    if (!wrap) return;

    var sectionId = btn.getAttribute('data-section-id');
    var nextPath = btn.getAttribute('data-next-url');
    if (!sectionId || !nextPath) return;

    isLoading = true;

    var label = btn.querySelector('.collection-load-more__label');
    var loadingEl = btn.querySelector('.collection-load-more__loading');
    var collectionRoot = container.querySelector('.collection:not(.collection--empty)');

    var url = new URL(nextPath, window.location.href);
    url.searchParams.set('section_id', sectionId);

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (label) label.classList.add('hidden');
    if (loadingEl) loadingEl.classList.remove('hidden');
    if (collectionRoot) collectionRoot.classList.add('loading');

    fetch(url.toString())
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetchedContainer = doc.getElementById('ProductGridContainer');
        if (!fetchedContainer) throw new Error('ProductGridContainer missing');

        var currentGrid = document.querySelector('#product-grid');
        var newGrid = fetchedContainer.querySelector('#product-grid');
        if (!currentGrid || !newGrid) throw new Error('product-grid missing');

        newGrid.querySelectorAll('li.grid__item').forEach(function (li) {
          currentGrid.appendChild(li);
        });

        var newWrap = fetchedContainer.querySelector('[data-collection-load-more]');
        var newBtn = newWrap && newWrap.querySelector('[data-load-more]');
        if (newBtn) {
          wrap.innerHTML = newWrap.innerHTML;
        } else {
          wrap.remove();
          disconnectAutoLoad();
        }

        if (window.PlatiniWishlist && typeof window.PlatiniWishlist.syncButtons === 'function') {
          window.PlatiniWishlist.syncButtons();
        }

        document.dispatchEvent(new CustomEvent('platini:product-grid:updated'));

        scheduleAutoLoadCheck();
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (label) label.classList.remove('hidden');
        if (loadingEl) loadingEl.classList.add('hidden');
      })
      .finally(function () {
        if (collectionRoot) collectionRoot.classList.remove('loading');
        isLoading = false;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    var container = document.getElementById('ProductGridContainer');
    if (!container || !container.contains(btn)) return;
    e.preventDefault();
    loadNextPage(btn);
  });

  window.PlatiniCollectionLoadMore = {
    pause: function () {
      paused = true;
      disconnectAutoLoad();
    },
    resume: function () {
      paused = false;
      scheduleAutoLoadCheck();
    }
  };

  function boot() {
    observeProductGridContainer();
    setupAutoLoad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
